import { Box, Typography } from '@mui/material';

import type { TFunction } from 'i18next';

export const BTSignatureMessage = () => {
  return (
    <Box p={0}>
      <Typography fontSize={12}>
        By clicking submit, I hereby attest that the medical record entry for the date of service
        listed in the session note accurately and completely reflects my entries, comments and
        notations as the clinician for the services I provided to the client on the date of service
        listed in the session note, including, but not limited to. I attended and performed the
        services on the date of service for the period indicated; and I have completed the necessary
        paperwork for the submission of these notes.
      </Typography>
      <Typography fontSize={12}>
        I certify that I understand that I am not permitted to work more than four (4) hours
        consecutively, without taking a minimum thirty (30) minute break and I further certify that
        have not worked more than four (4) hours consecutively, without a minimum thirty (30) minute
        break, in this session. I understand that any falsification, omission, or concealment of
        facts may subject me to administrative, civil, or criminal liability as well as termination
        of my employment with the company.
      </Typography>
    </Box>
  );
};

export const ParentSignatureMessage = () => {
  return (
    <Box p={0}>
      <Typography fontSize={12}>
        By clicking submit, I, as client (behalf of myself), or parent (on behalf of the client), or
        other appropriate person (on behalf of the client) confirm that the client has received the
        services rendered by company on the date of service set forth in the session notes.
      </Typography>
    </Box>
  );
};

export const VBTSignatureMessage = () => {
  return (
    <Box p={0}>
      <Typography fontSize={12}>
        By clicking submit, I hereby attest that the medical record entry for the date of service
        listed in the session note accurately and completely reflects my entries, comments and
        notations as the clinician for the services I provided to the client on the date of service
        listed in the session note, including, but not limited to. I attended and performed the
        services on the date of service for the period indicated; and I have completed the necessary
        paperwork for the submission of these notes.
      </Typography>
      <Typography fontSize={12} mt={1}>
        I understand that any falsification, omission, or concealment of facts may subject me to
        administrative, civil, or criminal liability as well as termination of my employment with
        the company.
      </Typography>
    </Box>
  );
};

export const GuardianSignatureMessage = (t: TFunction<'sessionNotes'>) => {
  return (
    <Box p={0}>
      <Typography fontSize={12}>{t('parentSignature.message')}</Typography>
    </Box>
  );
};
